import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
  en: {
    // Header
    header_1: 'Home',
    header_2: 'About us',
    header_3: 'Contact',
    header_4_1: 'We enhance Digital Experiences',
    header_4_2: ' With great Digital Products ',
    header_4_3: 'design company',
    header_5_1: 'We deliver',
    header_5_2: 'high quality solutions',
    header_5_3: ' built by our',
    header_5_4: 'award-winning team',
    header_6: 'Work',
    header_7: 'Blog',
    header_8_1: 'We work',
    header_8_2: 'with our clients',
    header_8_3: 'to create efficient solutions',
    header_9: 'Careers',
    header_10: 'Follow your bliss.',
    header_11: 'Join us!',
    header_12: 'Book a call',
    header_13: 'Blog',

    // About
    about_1_1: 'Who',
    about_1_2: 'we',
    about_1_3: 'are',
    about_1_4: ' ',
    about_2_1: 'Bliss Application was born in 2009, and we’re proud to say that it only took a couple of years for us to become a leader in software development within Portugal - with a team of more than 180 people.',
    about_2_2: 'Today, we’re global - as for clients and teams. From product managers to software engineers, from designers and marketeers to creatives, our offices are located in Lisbon, Porto and Boston, but we deliver high-end products that craft digital experiences, ',
    about_2_3: 'worldwide.',
    about_2_4: 'We’re part of something bigger - ',
    about_2_5: 'WYgroup ',
    about_2_6: '-, the largest national digital marketing group in Portugal. WYgroup was created in 2001 and is currently a holding company of 7 independent companies and employs more than 400 people.',
    about_3_1: 'Why',
    about_3_2: 'us',
    about_3_3: '?',
    about_4_1: 'We have a clear mission: provide our customers great digital products that craft superior digital experiences to their clients.',
    about_4_2_1: 'We’ve launched more than 100 Digital Products in the last decade, with an experienced team of designers, engineers and creatives that work side by side with each client. Only this way we’re able to understand their needs to ensure that every single person that interacts with it is a satisfied client.',
    about_4_2_2: 'Our Product Design process is unique, yet inspired by proven methodologies such as Google Design Sprint and Design Thinking. This process is carried by certified professionals, always in close collaboration with our amazing IT team, our designers and our creatives in order to choose the best technical approach to deliver on time, on budget and with great quality.',
    about_4_3: 'See some examples',
    about_5: 'We craft digital experiences that people love',

    // Work
    work_1: '',
    work_2: 'Browse our work',
    work_11: 'From banking to energy, from retail to healthcare, from telco to many more, our amazing multi-talented teams have build end-to-end software applications for multiple industries.',
    work_12: 'Technology is constantly evolving. That’s why we have a dedicated R&D team working with new technology. Get in touch to learn more.',

    // Cases
    skills: 'SKILLS',
    awards: 'Awards',

    // Careers
    careers_1: 'We’re Hiring',
    careers_2: 'Bliss Applications is a people-first company always looking for fresh or experienced talented people to join our journey to create mind-blowing digital products.',
    careers_3_1: 'Our headquarters is in Lisbon, Portugal, with an amazing ocean view, but we also have offices in Porto (PT) and Boston (USA).',
    careers_3_2: 'As a leading mobile-centric design and development company that grows every day, our teams constantly need to be reinforced with project managers, engineers, designers, marketeers and creatives to achieve even more local and international success.',
    careers_4: 'Check below our current job openings and prepare yourself for a wonderful and exciting journey that will start right after you send your application.',
    careers_5: 'Open Positions',
    careers_6: '{positions} OPEN POSITIONS',
    careers_7: 'No jobs available',
    careers_8: 'Come back in the future or surprise us with a spontaneous application. </br> Let’s talk at ',
    careers_9: 'jobs@blissapplications.com.',

    // Info
    info_1: 'We help our customers giving their clients great digital experiences through great Digital Products built with strong creative design thinkers and Technology expertise',

    // Services
    services_1: 'What we do',
    services_2_1: 'At Bliss Applications, we transform great ideas into excellent Digital Products.',
    services_3: 'Product Strategy',
    services_4: 'Product Design',
    services_5: 'Product Dev & QA',
    services_6: 'Maintenance & Growth',
    services_7: 'Turning ideas into working products is at the core of what we do. We work with clients to define a problem that needs to be solved. Then we research, analyze the market to create a product roadmap, and setup a team that will ensure we build the best solution.',
    services_8: 'From napkin sketch to hi-fi journeys, from MVP prototypes to full-fledged Design Systems, our team co-creates with the user the best possible digital experience.',
    services_9: 'Engineering and Design weigh the same on a product’s success. That’s why our teams work together to build solutions, integrated in the current technology landscape, in an elegant and efficient way.',
    services_10: 'A Product is always evolving once it’s launched and we know it. At Bliss we have ongoing work with our clients to assure the stability, scalability and, ideally, the growth of each solution we build.',
    services_11: 'Mobile Apps',
    services_12: 'Digital Product Strategy and Design',
    services_13: 'Digital Customer Experience',
    services_14: 'eCommerce',
    // Footer
    footer_1_1: 'Copyright © Bliss Applications {year}.',
    footer_1_2: 'All rights reserved.',
    footer_2: 'Follow your bliss.',
    footer_3: 'Knowing all about global trends related to tech, design and marketing strategy is your thing? Enter your email and we’ll send them to you.',
    footer_4: 'Have a project in mind?',
    footer_5: 'Our 4 Locations',
    footer_6: 'BOSTON',
    footer_8: 'PORTO',
    footer_9: 'LISBON',
    footer_10: 'co-financed by:',
    footer_11: 'COPENHAGEN',

    // Input
    input_1: 'Enter your email...',

    // Buttons
    button_1: 'GET IN TOUCH',
    button_2: 'FIND OUT MORE',
    button_3: 'VIEW MAP',
    button_4: 'CHECK OUR WORK',
    button_5_1: 'PLAY',
    button_5_2: 'REEL',

    // Contacts
    contacts_list: [
      {
        title: 'LISBON',
        street: ['Avenida Marginal', 'Edf. Parque Oceano, 4º piso', 'Santo Amaro de Oeiras', '2780-322 Oeiras, Portugal'],
        link: { href: 'tel:+351 214 544 553', number: '+351 214 544 553' },
        image: { small: '/static/images/office-lisbon-mobile.jpg, /static/images/office-lisbon-mobile@2x.jpg 2x,/static/images/office-lisbon-mobile@3x.jpg 3x', large: '/static/images/office-lisbon.jpg, /static/images/office-lisbon@2x.jpg 2x', src: '/static/images/office-lisbon.jpg' },
        imageAlt: 'Lisbon Office',
        map: 'https://goo.gl/JxzwPP'
      },
      {
        title: 'BOSTON',
        street: ['', 'WeWork c/o WYgroup USA', '33 Arch Street', 'Boston, MA 02110'],
        link: { href: 'tel:+1 (857)-28-0503', number: '+1 (857)-285-0503' },
        image: { small: '/static/images/office-boston-mobile.jpg, /static/images/office-boston-mobile@2x.jpg 2x, /static/images/office-boston-mobile@3x.jpg 3x', large: '/static/images/office-boston.jpg, /static/images/office-boston@2x.jpg 2x, /static/images/office-boston@3x.jpg 3x', src: '/static/images/office-boston.jpg' },
        imageAlt: 'Boston Office',
        map: 'https://goo.gl/R7Hppb'
      },
      {
        title: 'PORTO',
        street: ['UPTEC Baixa', 'Praça Coronel Pacheco 2 - Sala 139', '4050-453 Porto, Portugal'],
        link: { href: 'tel:+351 220 731 365', number: '+351 220 731 365' },
        image: { small: '/static/images/office-porto.jpg', large: '/static/images/office-porto.jpg', src: '/static/images/office-porto.jpg' },
        imageAlt: 'Porto Office',
        map: 'https://maps.app.goo.gl/qdjLL6PFBWMJ2Y5XA'
      },
      {
        title: 'COPENHAGEN',
        street: ['Mølholmvej 11', '7100 Vejle', 'Denmark'],
        link: { href: 'tel:+45 31 41 91 92', number: '+45 31 41 91 92' },
        image: { small: '/static/images/office-copenhagen-mobile.jpg, /static/images/office-copenhagen-mobile@2x.jpg 2x', large: '/static/images/office-copenhagen.jpg, /static/images/office-copenhagen@2x.jpg 2x', src: '/static/images/office-copenhagen.jpg' },
        imageAlt: 'Copenhagen Office',
        map: 'https://maps.app.goo.gl/d549itEGpxdztwt5A'
      }
    ],
    contact_5: 'Your Name',
    contact_6: 'Email',
    contact_7: 'Phone',
    contact_8: 'Project Description',
    contact_9: 'Have a project in mind? We’re here to help.',
    contact_10: 'Tell us a bit more about your project.',

    // project
    project_1: 'We would love to hear from you!',
    project_2: 'EMAIL US',
    project_3: '+1 (857) 285-0503',
    project_4: '+351 214 544 553',
    project_5: 'info@blissapplications.com',
    project_6: 'Have a project in mind? Feel free to use the form below to tell us a bit more about your project.',
    project_7: '+351 220 731 365',
    project_8: 'Have a project in mind?',
    project_9: 'Feel free to use the form below to tell us a bit more about your project.',
    project_10: 'NEW BUSINESS',
    project_11: 'dpo@wygroup.net',
    project_12: '+45 31 41 91 92',

    // Book call
    book_call_1: 'Every great conversation <strong>starts with a call</strong>.',
    book_call_2: 'Meet the team working with an ocean view.',
    book_call_3: 'Have a project in mind?',
    book_call_bullets: [
      {
        title: 'Book a call with one of our experts'
      },
      {
        title: 'Get to know our work'
      },
      {
        title: 'Discover how we can help move your projects forward'
      }
    ],
    book_call_form: 'https://webforms.pipedrive.com/f/1Cat0PWo2eH4rl4ZHn0Vs2XqDd76b6nwGwQbQ2NrZJYpxKI0luR7y7sQJnJBVsNR9',

    // Messages
    message_1: 'Thanks for subscribing',
    message_2: 'Your subscription to our list has been confirmed. Thanks for subscribing!',
    message_3: 'Thank you for getting in touch!',
    message_4: 'We appreciate you contacting us about your project. One of our account managers will be in touch with you shortly. In the meantime, have a blissful day!',
    message_5: 'There are errors below',
    message_6: 'CONTINUE TO OUR WEBSITE',
    message_7: 'Subscribe',

    // Cookies
    cookies_1: 'Bliss Applications uses cookies on this site with the aim of improving your browsing experience. If you want to know more about our cookies or how to disable them, go to our Cookies Policy. By continuing on this site, you agree to the use of cookies.',
    cookies_2: 'SHOW DETAILS',
    cookies_3: 'ACCEPT ALL',
    cookies_4: 'SAVE CHANGES',

    privacy_policy: 'Privacy Policy',
    security_policy: 'Information Security Policy',
    privacy_settings: 'Privacy Settings',
    cnpd: 'www.cnpd.pt',
    cookies_list: [
      {
        id: '0',
        title: 'Your Privacy',
        text: 'When you visit any web site, it may store or retrieve information on your browser, mostly in the form of cookies. This information might be about you, your preferences, your device or used to make the site work as you expect it to. The information does not usually identify you directly, but it can give you a more personalized web experience. You can choose not to allow some types of cookies. Click on the different category headings to find out more and change our default settings. However, you should know that blocking some types of cookies may impact your experience on the site and the services we are able to offer.',
        toggle: false,
        link: false
      },
      {
        id: '1',
        title: 'Strictly Necessary Cookies',
        text: 'These cookies are necessary for the website to function and cannot be switched off in our systems. They are usually only set in response to actions made by you which amount to a request for services, such as setting your privacy preferences, logging in or filling in forms. You can set your browser to block or alert you about these cookies, but some parts of the site may not work then.',
        toggle: false,
        link: false
      },
      {
        id: '2',
        title: 'Targeting Cookies',
        text: 'These cookies allow us to count visits and traffic sources, so we can measure and improve the performance of our site. They help us know which pages are the most and least popular and see how visitors move around the site. All information these cookies collect is aggregated and therefore anonymous. If you do not allow these cookies, we will not know when you have visited our site.Targetting Cookies: These cookies are set through our site by our advertising partners. They may be used by those companies to build a profile of your interests and show you relevant ads on other sites. They work by uniquely identifying your browser and device. If you do not allow these cookies, you will not experience our targeted advertising across different websites.',
        toggle: true,
        link: false
      },
      {
        id: '3',
        title: 'Privacy Policy',
        text: '',
        toggle: false,
        link: true
      }],

    // Toggle
    active: 'Active',

    // Rgpd labels
    rgdp_concent: 'I hereby authorize Bliss Applications to collect my personal data for a maximum period of twelve months. This consent can be changed at any time by sending an e-mail to info@blissapplications.com.',
    marketing_concent: 'I hereby authorize Bliss Applications to collect my personal data for a maximum period of twelve months for marketing campaigns. This consent can be changed at any time by sending an e-mail to info@blissapplications.com.',

    // Errors Messages
    api_error: 'API not responding',
    page_error: 'Page not found',

    // Social sharing
    share_text: 'Share this post',
    social_title: 'Bliss Applications: User-centered design company',

    // Handoff
    handoff_title: 'Handoff, a film about collaboration',
    handoff_subtitle: '2023',
    handoff_description: 'Collaboration is the most effective way to build a digital solution. Discover how a team of designers and developers cooperate to reduce friction, ensure consistency and create innovation.',
    handoff_teaser_button: 'Watch the Teaser',
    handoff_link_button: 'Learn More'

  }
};

export default new VueI18n({
  locale: 'en',
  messages
});



// WEBPACK FOOTER //
// src/utils/i18n.js